import React from 'react';
import { ScoringResult } from '../utils/kinematicsScoring';
import { getLevelBand } from '../utils/kinematicsScoring';
import './VideoKinematicsKPI.css';

interface VideoKinematicsKPIProps {
  scoringResult: ScoringResult;
}

const VideoKinematicsKPI: React.FC<VideoKinematicsKPIProps> = ({ scoringResult }) => {
  const levelBand = getLevelBand(scoringResult.overallScore);
  
  const getScoreColor = (score: number) => {
    if (score >= 80) return '#4caf50'; // Green
    if (score >= 60) return '#ffc107'; // Yellow
    return '#f44336'; // Red
  };

  const getLevelColor = (level: string) => {
    switch (level) {
      case 'Elite':
        return '#4caf50';
      case 'Standard':
        return '#ffc107';
      case 'Development':
        return '#f44336';
      default:
        return '#567ad8';
    }
  };

  return (
    <div className="kinematics-kpi-container">
      {/* Headline KPI */}
      <div className="kpi-main">
        <div className="kpi-label">Kinematic Match Score</div>
        <div 
          className="kpi-value" 
          style={{ color: getScoreColor(scoringResult.overallScore) }}
        >
          {scoringResult.overallScore.toFixed(1)}
        </div>
        <div className="kpi-range">/ 100</div>
      </div>

      {/* Level Band Indicator */}
      <div className="kpi-level">
        <span className="level-label">Level:</span>
        <span 
          className="level-badge"
          style={{ 
            backgroundColor: getLevelColor(levelBand) + '20',
            color: getLevelColor(levelBand),
            borderColor: getLevelColor(levelBand) + '40'
          }}
        >
          {levelBand}
        </span>
      </div>

      {/* Supporting KPIs */}
      <div className="kpi-supporting">
        <div className="supporting-kpi">
          <div className="supporting-label">Parameters in Range</div>
          <div className="supporting-value">
            {scoringResult.metricsInRange}/{scoringResult.totalMetrics}
          </div>
        </div>

        <div className="supporting-kpi">
          <div className="supporting-label">Top 3 Priorities</div>
          <div className="supporting-value priorities">
            {scoringResult.topPriorities.map((p, idx) => (
              <span key={idx} className="priority-item">
                {idx + 1}. {p.score.toFixed(0)}
              </span>
            ))}
          </div>
        </div>

        <div className="supporting-kpi">
          <div className="supporting-label">Confidence Summary</div>
          <div className="supporting-value confidence">
            <span className="conf-item">{scoringResult.confidenceSummary.high} high</span>
            <span className="conf-item">{scoringResult.confidenceSummary.medium} medium</span>
            <span className="conf-item">{scoringResult.confidenceSummary.proxy} proxy</span>
            <span className="conf-item">{scoringResult.confidenceSummary.placeholder} placeholder</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoKinematicsKPI;






